import config from '../../config';
import * as dummy from '../dummy/addressSearch';
import * as real from '../api/addressSearch';

const api = config.USE_DUMMY ? dummy : real;

/** 주소 검색 서비스 — 카카오 SDK or dummy fallback */
export const addressSearchService = {
  search: api.searchAddress,
};
